import { Button, ButtonProps } from 'antd';

const ActionBtn = (rest: ButtonProps) => {
  return <Button {...rest} />;
};

export default ActionBtn;
